import { tableTypeConstants } from "../actions/types";
const initialState = {
    table: undefined,
};
export const tableTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        case tableTypeConstants.SET_TABLE_TYPE:
            return Object.assign(Object.assign({}, state), { table: action.payload });
        default:
            return state;
    }
};
